import React from 'react';

import SelectableElement, {
    TSelectableElement,
} from '@r1-frontend/service-engineer-visit/components/SelectableElement';

import { Cost } from '@r1-frontend/ui-react/components/costs';

import * as S from './styled';

export type TTimeItemProps = {
    from: string | number,
    to: string | number,
    cost?: number,
    onClick: () => void,
} & TSelectableElement;

const TimeItem = ({ from, to, cost, ...props }: TTimeItemProps): JSX.Element => {
    return <SelectableElement {...props}>
        <S.TimeItem>
            {props.$selected ? <>{from}-{to}:00</> : <>{from}:00</>}
            {Number.isInteger(cost) && (
                <Cost>{String(cost)}</Cost>
            )}
        </S.TimeItem>
    </SelectableElement>;
};

export default TimeItem;
